<template>
	<div class="transform componetself" v-loading="pLoad">
		<!-- 发货通知单 -->
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index" :class="{'flex':item.type==7}">
						<c-filter :item="item" :form="filterForm" :line="true" :textMini="45" :VailShow="VailShow"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog"
					@click="selectOrder">查询</el-button>
			</div>
		</div>
		<div class="componet_body">
			<div class="body_btns">
				<template v-if="iscgy">
					<vxe-button type="text" class="tool-btn _icon_button" title="批量导入" @click="OpenTabImport"
						:disabled="unvailLoad||selectLog">
						<i class="iconfont icon-addDB iconSize "></i>批量导入
					</vxe-button>
					<vxe-button type="text" class="tool-btn _icon_button" title="新增" @click="createTRAN"
						:loading="createTRANload" :disabled="createTRANload||unvailLoad||selectLog">
						<i class="iconfont icon-AddwithcircleF iconSize "></i>新增
					</vxe-button>
					<vxe-button type="text" class="tool-btn _icon_button" title="修改" @click="upd_Tran"
						:disabled="unvailLoad||selectLog">
						<i class="iconfont icon-update iconSize "></i>修改
					</vxe-button>
					<vxe-button type="text" class="tool-btn _icon_button" title="删除" @click="Close_Tran"
						:loading="closeLoad" :disabled="unvailLoad||selectLog||closeLoad||createTRANload">
						<i class="iconfont icon-shanchu iconSize "></i> 关闭
					</vxe-button>
					<vxe-button type="text" class="tool-btn _icon_button" title="关闭" @click="Del_Tran"
						:loading="unvailLoad" :disabled="unvailLoad||selectLog||closeLoad">
						<i class="iconfont icon-shanchu iconSize "></i>删除
					</vxe-button>
				</template>
				<template v-else>
					<!-- <vxe-button  type="text" class="tool-btn _icon_button" title="生成送货单" @click="trans_asn"
						:loading="TransToASNLoad" :disabled="TransToASNLoad||selectLog||VDAPRILoad||cload">
						<i class="iconfont icon-transform1 iconSize "></i>生成送货单
					</vxe-button> -->
					<vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
						@click="showCreateModal(true)" :loading="VDAPRILoad" :disabled="TransToASNLoad||selectLog||VDAPRILoad||cload"
						>
						<i class="iconfont icon-print iconSize "></i>标签打印
					</vxe-button>
					<vxe-button type="text" class="tool-btn _icon_button" title="已生成标签查看" 
						:loading="cload" @click="VDAPRCreatedFn"
						:disabled="TransToASNLoad||selectLog||VDAPRILoad||cload">
						<i class="iconfont icon-print iconSize "></i>已生成标签查看
					</vxe-button>
				</template>
				
				<!-- <vxe-button type="text" class="tool-btn _icon_button" title="查看ASN" @click="readASN"
					:loading="readASNLoad" :disabled="readASNLoad">
					<i class="iconfont icon-detail-fill iconSize "></i>查看ASN
				</vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button" title="导出" @click="exportData"
					:loading="exportload" :disabled="exportload||unvailLoad||createTRANload||selectLog">
					<i class="iconfont icon-export iconSize "></i>导出
				</vxe-button>
			</div>
			<div class="body_content">
				<!-- checkbox -->
				<c-table ref="ctablemain" :table="table" :coltype="'checkbox'" @FitColumns="table.head=$event"
					@listenToChild="listenToChild"></c-table>

			</div>
		</div>
		<vxe-modal ref="addModal" title="新增到货计划" :zIndex="2000" :loading="addmodalLoad" width="100%" height="100%"
			:mask="false" :show-zoom="false" :resize="false" :lock-view="true" :before-hide-method="addmodal_hide">
			<template v-slot>
				<div class="flex flex_column" style="height: 100%;">
					<div class="flex flex_row flex-nowrap flex-hc">
						<vxe-button type="text" class="tool-btn _icon_button btn_step" title="上一步" @click="first_step"
							:disabled="addmodalLoad" v-if="cstep=='addItem'">
							上一步
						</vxe-button>
						<vxe-button type="text" class="tool-btn _icon_button btn_step" title="下一步" @click="sencond_step"
							v-if="cstep=='getSource'">
							下一步
						</vxe-button>
						<vxe-button type="text" class="tool-btn _icon_button" title="新增保存" @click="save_add"
							v-if="cstep=='addItem'" :disabled="addmodalLoad" :loading="addmodalLoad">
							<i class="iconfont icon-save iconSize "></i>新增保存
						</vxe-button>
					</div>
					<el-main class="trans_main_modal" style="flex: 1 1 auto;">
						<c-table ref="ctablecreatedztList" key="3" :table="addTable[cstep]"
							style="height: calc(100% - 1.6rem);" @FitColumns="addTable[cstep].head=$event"
							@listenToChild="lient(cstep,$event)" :colfilter="true" v-show="cstep=='getSource'"
							class="table_height print_selecttable_div" :coltype="cstep=='getSource'?'checkbox':'seq'">
						</c-table>
						<c-table ref="ctablecreatedztList1" key="4" :table="addTable[cstep]"
							style="height: calc(100% - 1.6rem);" @FitColumns="addTable[cstep].head=$event"
							@listenToChild="lient(cstep,$event)" :colfilter="true" v-show="cstep!='getSource'"
							class="table_height print_selecttable_div" :coltype="cstep=='getSource'?'checkbox':'seq'">
						</c-table>
					</el-main>
				</div>

			</template>
		</vxe-modal>
		<vxe-modal ref="updateModal" title="修改到货计划" :zIndex="2000" :loading="updLoad" width="30rem" height="15rem"
			:mask="true" :show-zoom="false" :resize="false" :lock-view="true">
			<template v-slot:header>
				<vxe-button type="text" class="tool-btn _icon_button" title="保存" @click="upd_request"
					:disabled="updLoad" :loading="updLoad">
					<i class="iconfont icon-save iconSize "></i>保存
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" @click="exit" :disabled="updLoad">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<div class="flex flex_column flex-hc" style="height: 100%;">
					<div class="updItem">
						<template v-for="item in updItem">
							<c-filter :key="item.name" :form="updateForm" :item="item" :line="true" :textMini="45"></c-filter>
						</template>
						<!-- <c-filter :form="updateForm" :item="updItem[0]" :line="true" :textMini="45"></c-filter>
						<c-filter :form="updateForm" :item="updItem[1]" :line="true" :textMini="45"></c-filter> -->
					</div>
					
				</div>

			</template>
		</vxe-modal>
		<vxe-modal ref="CreateModal" title="生成标签" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			:before-hide-method="labelmodal_hide" 
			remember>
			<template v-slot:header>
				<span class="filter_item flex flex_row flex-nowrap flex-vc" style="display: inline;">
					<span>标签模板</span>
					<el-select v-model="printMoudle">
						<el-option v-for="(item,index) in moduleList" :key="index" :value="item['FTNumber']"
							:label="item['FTName']"></el-option>
					</el-select>
				</span>
				<vxe-button type="text" class="tool-btn _icon_button" title="行删除" @click="labeldeleteLine"
					v-show="activeName=='first'" 	:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-shanchu iconSize "></i>行删除
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="生成标签"
					v-show="activeName=='first'"  :loading="createLoad" @click="CREATElabelfn"
					:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-create iconSize "></i>生成标签
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
					v-show="activeName!='first'" :loading="printLoad" @click="labelPrinttwodata"
					:disabled="createLabelLoad||printLoad||calcuteLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出"
					:disabled="createLabelLoad||createLoad||calcuteLoad" @click="showCreateModal(false)">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName" @tab-click="TABCHANGE">
					<el-tab-pane label="标签打印信息" name="first"></el-tab-pane>
					<el-tab-pane label="本次生成标签" name="second"></el-tab-pane>
					<el-tab-pane label="最小包装标签" name="third" v-if="CanZT"></el-tab-pane>
					<el-tab-pane label="箱标签" name="four" v-if="CanZT"></el-tab-pane>
					<!-- <el-tab-pane label="历史已生成标签" name="third"></el-tab-pane> -->
				</el-tabs>
				<!-- {{createCode.key}}/{{createCode.key+1}}/{{createCode.key+2}} -->
				<el-main class="pursh_main asnDeatail_createdLabel" style="height: calc(100% - 2.8rem);">
					<c-table v-if="activeName=='first'" ref="ctablecreate"
						key="1"
						:table="createCode.table"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						@listenToChild="listenToChild2" @loading="calcuteLoad=$event"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='second'" ref="ctablecreated"
						key="2"
						:table="createCode.tabled"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='third'" ref="ctablecreated_package"
						key="3"
						:table="createCode.packageTable"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='four'" ref="ctablecreated_zt"
						key="4"
						:table="createCode.ztTable"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						coltype="seq" >
					</c-table>
					<!-- <c-table v-if="activeName=='third'" ref="ctablecreatedList"
						key="3"
						:table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						@listenToChild="listenToChild" class="table_height print_selecttable_div"
						coltype="checkbox" >
					</c-table> -->
				</el-main>
			</template>
		</vxe-modal>
		<vxe-modal ref="CreatedModal" title="已生成标签查看" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			:before-hide-method="labelmodal_hide"
			remember>
			<template v-slot:header>
				<span class="filter_item flex flex_row flex-nowrap flex-vc" style="display: inline;">
					<span style="font-weight: 600;">标签模板</span>
					<el-select v-model="printMoudle"  :disabled="!createdChangeP">
						<el-option v-for="(item,index) in moduleList" :key="index" :value="item['FTNumber']"
							:label="item['FTName']"></el-option>
					</el-select>
				</span>
				<el-checkbox style="margin-left: 12px;margin-right: 12px;" v-model="createdChangeP">切换模板</el-checkbox>
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
					:loading="printLoad" @click="labelPrinttwodata"
					:disabled="createLabelLoad||printLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="作废标签" @click="UNVAILVADA"
					:loading="UNVAILVDALOAD" 
					:disabled="createLabelLoad||UNVAILVDALOAD" v-if="!IsCGY">
					<i class="iconfont icon-shanchu iconSize "></i>作废标签
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出"
					:disabled="createLabelLoad" @click="VDAPRCreatedFnClose">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-main class="pursh_main" style="height: calc(100% - 1.6rem);">
					<c-table ref="ctablecreatedList"
						key="3"
						:table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						@listenToChild="listenToChild2" class="table_height print_selecttable_div"
						coltype="checkbox" :colfilter="true" >
					</c-table>
				</el-main>
			</template>
		</vxe-modal>
	</div>
</template>
<script>
	import filterData from './filters.js';
	import tablehead from './tablehead.js';
	import print from './print.js'
	export default {
		props:{
			pageId: {
				type: String,
				default:''
			},
		},
		data() {
			return {
				filterForm: {},
				table: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				selectLog: false,
				TransToASNLoad:false,
				createTRANload: false,
				exportload: false,
				unvailLoad: false,
				closeLoad:false,
				updLoad:false,
				checkList: [],
				readASNLoad: false,
				pLoad: false,
				filterList: [],
				cstep: 'getSource',
				addmodalLoad: false,
				addTable: {
					getSource: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
						_height: undefined,
						checkList: []
					},
					addItem: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
						_height: undefined
					}
				},
				updateForm: {},
				updItem:[],
			}
		},
		mixins:[print],
		computed: {
			// filterList() {
			// 	return filterData;
			// },
			userinfo() {
				return this.$store.getters.UserInfo || {};
			},
			iscgy() {
				return this.userinfo.accountType == 'cgy'
			},
			// updItem() {
			// 	return [{
			// 			name: 'FASNDATE',
			// 			Display: '到货日期',
			// 			type: 3,
			// 		},
			// 		{
			// 			name:'FQTY',
			// 			Display:'到货数量',
			// 			type:1,
			// 			dataType:'number',
			// 			min:0
			// 		},
			// 	]
			// },

		},
		methods: {
			lient(cstep,$event){
				console.log('listen',$event)
				if($event&&$event['checkList']){
					this.addTable[cstep].checkList=$event['checkList']
				}
			},
			trans_asn(){
				try {
					if(this.checkList.length == 0) throw '请先选择行'
					if(this.TransToASNLoad) return;
					this.TransToASNLoad=true;
					this.$BH().base.http({
						url: 'Web/Trans_asn',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FSourceData: this.checkList
						},
						success: (res) => {
							this.$tab.openSpecTab('送货单明细页面','asnDetail',{
								order:res.data.value,
								isadd:true
							})
						},
						loadingcontrol: (res) => {
							this.TransToASNLoad = false;
						}
					});
				} catch (e) {
					this.$BH().message(e);
					this.TransToASNLoad = false;
				}
			},
			upd_request(){
				try {
					// if(!this.updateForm['_fid']||!this.updateForm['_fitemstamp'])
					// 	throw '更新的重要参数不存在，请联系管理员检查';
					let rowForm=JSON.parse(JSON.stringify(this.checkList[0]));
					for(let i in this.updateForm){
						rowForm[i]=this.updateForm[i]
					}
					if(this.updLoad) return;
					this.updLoad=true;
					this.$BH().base.http({
						url: 'Web/Trans_UPD',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FUPDDATA: rowForm,
							PageId:this.pageId
						},
						success: (res) => {
							//关闭弹框
							this.$BH().message(res.data.value);
							setTimeout(() => {
								this.exit();
							}, 0);
							this.selectOrder()
						},
						loadingcontrol: (res) => {
							this.updLoad = false;
						}
					});
				} catch (e) {
					this.$BH().message(e);
					this.updLoad = false;
				}
			},
			exit() {
				if (this.$refs.updateModal) this.$refs.updateModal.close();
				this.updateForm = {};
			},
			upd_Tran() {
				try {
					if(this.checkList.length == 0) throw '请先选择行'
					//校验每一行数据是否填写了指定的值
					var goupdate=() => this.$refs.updateModal && this.$refs.updateModal.open();
					if (this.checkList.length > 1) {
						//选择 是否同时修改多行数据
						// this.$BH().confirm('当前选中多行数据，是否继续修改',
						// 	(res) => {
						// 		if (res == 'confirm') {
						// 			goupdate();
						// 		}
						// 	},
						// )
						throw '不允许多行数据同时修改'
					} else{
						this.updItem.map(item=>this.updateForm[item.name]=this.checkList[0][item.name]);
						this.updateForm['_fid']=this.checkList[0]['_fid'];
						this.updateForm['_fitemstamp']=this.checkList[0]['_fitemstamp'];
						this.updateForm=JSON.parse(JSON.stringify(this.updateForm))
						goupdate();
					} 
				} catch (e) {
					this.$BH().message(e);
					this.unvailLoad = false;
				}
			},
			//作废到货计划
			Del_Tran() {
				try {
					//校验每一行数据是否填写了指定的值
					if (this.checkList.length == 0) throw '请先选择行';
					this.$BH().confirm('是否确定删除？',
						(res) => {
							if (res == 'confirm') {
								if (this.unvailLoad) return;
								this.unvailLoad = true;
								this.$BH().base.http({
									url: 'Web/Trans_Delete',
									data: {
										FUser: this.userinfo.pfnumber,
										gysFUser: this.userinfo.fnumber,
										FType: this.userinfo.accountType,
										FDelDATA: this.checkList,
										PageId:this.pageId
									},
									success: (res) => {
										//关闭弹框
										this.$BH().message(res.data.value);
										this.selectOrder();
									},
									loadingcontrol: (res) => {
										this.unvailLoad = false;
									}
								});
							}
						},
					);
					
				} catch (e) {
					this.$BH().message(e);
					this.unvailLoad = false;
				}
			},
			//关闭到货计划
			Close_Tran() {
				try {
					//校验每一行数据是否填写了指定的值
					if (this.checkList.length == 0) throw '请先选择行';
					this.$BH().confirm('是否确定关闭？',
						(res) => {
							if (res == 'confirm') {
								if (this.closeLoad) return;
								this.closeLoad = true;
								this.$BH().base.http({
									url: 'Web/Trans_Close',
									data: {
										FUser: this.userinfo.pfnumber,
										gysFUser: this.userinfo.fnumber,
										FType: this.userinfo.accountType,
										FDelDATA: this.checkList,
										PageId:this.pageId
									},
									success: (res) => {
										//关闭弹框
										this.$BH().message(res.data.value);
										this.selectOrder();
									},
									loadingcontrol: (res) => {
										this.closeLoad = false;
									}
								});
							}
						},
					);
					
				} catch (e) {
					this.$BH().message(e);
					this.closeLoad = false;
				}
			},
			//保存新增
			save_add() {
				try {
					//校验每一行数据是否填写了指定的值
					for (let i in this.addTable.addItem.data) {
						let row = this.addTable.addItem.data[i];
						if (!row['FQTY'] || Number(row['FQTY']) <= 0)
							throw `请检查第${Number(i)}行的到货数量`
						if (!row['FASNDATE']) throw '到货日期不能为空';
					}
					if (this.addmodalLoad) return;
					this.addmodalLoad = true;
					this.$BH().base.http({
						url: 'Web/Trans_SAVE',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FSAVEDATA: this.addTable.addItem.data,
							pageId:this.pageId
						},
						success: (res) => {
							//关闭弹框
							this.$BH().message(res.data.value);
							setTimeout(() => {
								this.$refs.addModal && this.$refs.addModal.close();
								this.selectOrder()
							}, 0);
						},
						loadingcontrol: (res) => {
							this.addmodalLoad = false;
						}
					});
				} catch (e) {
					this.$BH().message(e);
					this.addmodalLoad = false;
				}
			},
			get_source() {
				try {
					if (this.addmodalLoad) return;
					this.addmodalLoad = true;
					this.$BH().base.http({
						url: 'Web/Trans_SOURCE',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							PageId:this.pageId
						},
						success: (res) => {
							let {
								head,
								data
							} = res.data.value;
							this.addTable['getSource'].head = head;
							this.addTable['getSource'].data = data;
							this.$refs.ctablecreatedztList?.updateCoulm();
						},
						loadingcontrol: (res) => {
							this.addmodalLoad = false;
						}
					});
				} catch (e) {
					this.$BH().message(e);
					this.addmodalLoad = false;
				}
			},
			//点击上一步 点击上一步的需要刷新数据源 然后将选中的行 重新框中
			first_step() {
				try {
					// this.get_source();
					this.cstep = 'getSource';
				} catch (e) {
					this.$BH().message(e);
				}
			},
			//新增的窗体中的step two 点击下一步
			sencond_step() {
				try {
					if (this.addTable['getSource'].checkList.length == 0) throw '请先选择采购订单数据源';
					//按照采购订单和采购行号 重新较对匹配
					//到货数量
					let addRows = JSON.parse(JSON.stringify(this.addTable['getSource'].checkList));
					if (this.addTable.addItem.data.length > 0) {
						addRows.map(row => {
							let index = this.addTable.addItem.data.findIndex(item => item['采购订单号'] == row[
								'采购订单号'] &&
								item['采购订单行号'] == row['采购订单行号']);
							console.log('FQTY', index, row['采购订单号'], row['采购订单行号'])
							if (index > -1) {
								row['FQTY'] = this.addTable.addItem.data[index]['FQTY']
							}
						});
					}

					this.addTable.addItem.data = addRows;
					this.addTable.addItem.head = JSON.parse(JSON.stringify(this.addTable['getSource'].head));
					this.addTable.addItem.head.push({
						"name": "FQTY",
						"title": "到货数量",
						"width": 150,
						"contentTip": true,
						"must": false,
						"edit": true,
						"hide": false,
						"valueType": "System.Int64",
						"IsSort": true
					})
					let index = this.addTable.addItem.head.findIndex(item => item.name == 'FASNDATE');
					console.log('到货日期', index)
					if (index > -1) {
						this.addTable.addItem.head[index]['edit'] = true;
						this.addTable.addItem.head[index]['valueType'] = 'date';
						this.addTable.addItem.head[index]['format'] = 'yyyy-MM-dd';
					}
					setTimeout(() => {
						this.cstep = 'addItem';
					}, 0);
					setTimeout(() => {
						this.$refs.ctablecreatedztList1?.updateCoulm();
					}, 100);
					//需要新增 送货数量的数据列
				} catch (e) {
					this.$BH().message(e);
				}
			},

			addmodal_hide() {
				if (this.addmodalLoad) {
					this.$BH().message('请稍等');
					throw new Error('请稍等')
				} else {
					//清除初始化参数
					this.cstep = 'getSource';
					this.addmodalLoad = false;
					this.addTable = {
						getSource: {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
							_height: undefined,
							checkList: []
						},
						addItem: {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
							_height: undefined
						}
					}
					this.$refs.ctablecreatedztList?.clearSelection();
				}

			},
			//打开批量导入的页签
			OpenTabImport() {
				try {
					this.$tab.openSpecTab((this.pageId=='cg'?'标准':'委外')+'到货计划导入', 'importTrans', {pageId:this.pageId});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			readASN() {
				try {
					console.log('chakan ASN')
					if (this.readASNLoad) return;
					this.readASNLoad = true;
					if (!this.checkList || this.checkList.length == 0) throw '请先选择发货通知单';
					let fids = [];
					for (let i in this.checkList) {
						fids.push(String(this.checkList[i]['_id']))
					}
					//是否多张asn在api校验
					// if(asncode=='') throw '发运单号码丢失，刷新数据或者联系管理员';

					//检查是否存在ASN 如果有的话就进行替换
					this.$BH().base.http({
						url: 'Web/CHECKEXISRSASN',
						data: {
							checkList: fids
						},
						success: (res) => {
							//查看ASN
							this.$tab.openSpecTab('ASN发运明细_修改', 'asnDetail', {
								checkOne: {
									FINTERID: res.data.value
								},
								isadd: false
							});
						},
						fail: (res) => {
							this.$BH().message(res.data.value);
							this.readASNLoad = false;
						},
						loadingcontrol: () => {
							this.readASNLoad = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.readASNLoad = false;
				}
			},
			listenToChild(e) {
				if (e && e.checkList) {
					this.checkList = e.checkList;
				}
			},
			selectOrder() {
				try {
					if (this.selectLog) return;
					this.selectLog = true;
					this.$BH().base.http({
						url: 'Web/GETTRANSFORMS',
						data: {
							filterList: this.filterList,
							filterForm: this.filterForm,
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							pageId:this.pageId
						},
						success: (res) => {
							let {
								head,
								data
							} = res.data.value;
							// this.table.head = head;
							this.table.data = data;
							this.$refs.ctablemain?.clearSelection();
							if (data.length > 0)
								this.$refs.ctablemain?.updateCoulm();
						},
						loadingcontrol: () => {
							this.selectLog = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog = false;
				}
			},
			//新增到货计划
			createTRAN() {
				try {
					if (this.createTRANload) return;
					this.createTRANload = true;
					//开启网络
					this.$refs.addModal && this.$refs.addModal.open();
					setTimeout(() => {
						this.get_source();
					}, 0);
					this.createTRANload = false;
				} catch (e) {
					this.$BH().message(e);
					this.createTRANload = false;

				}
			},
			//导出数据
			exportData() {
				try {
					if (this.exportload) return;
					this.exportload = true;
					//梳理数据的
					this.exportDataReq(this.table, () => {
						this.exportload = false;
					});
				} catch (e) {
					this.$BH().message(e);
					this.exportload = false;
				}
			},
			exportDataReq(table, callback) {
				let {
					head,
					data
				} = table;
				let headarr = [];
				head.map(item => {
					if (!item.hide) {
						headarr.push({
							name: item.name,
							title: (item.title || item.name)
						});
					}
				});
				this.$BH().base.http({
					url: 'Web/EXPORTDATATOEXCEL',
					data: {
						head: headarr,
						data: data
					},
					success: (res) => {
						let {
							value
						} = res.data;
						let basestr = res.data.value;
						if (basestr == '') {
							this.$BH().message('返回数据错误');
							callback && callback();
						} else
							this.$BH().DownLoadBase64({
								data: {
									name: '到货计划' + new Date().format('yyyyMMddhhmmss'),
									base64Str: basestr
								},
								loadingcontrol: () => {
									this.exportload = false;
									this.operate = false;
								}
							});
					},
					loadingcontrol: callback
				})
			},
			VailShow(filterItel){
				if (filterItel.allowUser) {
					let users = (filterItel.allowUser || '').split(',');
					let Index = users.findIndex(item => item == this.userinfo.accountType)
					return Index > -1;
				}
				// return true;
				return !filterItel['hide'] ;
			},
			PageInit() {
				try {
					this.pLoad = true;
					this.$BH().base.http({
						url: 'Web/GetTransPage_INIT',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							pageId:this.pageId
						},
						success: (res) => {
							// console.log(res)
							let {
								value
							} = res.data;
							// this.filterList = value.filterList || [];
							this.filterList = value.filterList || []//(value.filterList || []).filter(item => !item['allowUser'] || item['allowUser'].split(',').findIndex(jitem => jitem == this.userinfo.accountType)>-1);
							this.table.head = (value.head || []).filter(item => !item['allowUser'] || item['allowUser'].split(',').findIndex(jitem => jitem == this.userinfo.accountType)>-1);
							this.updItem=value.altercols
							this.NextDoc = value.NextDoc || '';
						},
						loadingcontrol: () => {
							this.pLoad = false;
						}
					});

				} catch (e) {
					this.$BH().message(e);
					this.pLoad = false;
				}
			},
		},
		mounted() {
			console.log(this.userinfoa)
			setTimeout(() => {
				this.$refs.ctablemain?.updateCoulm();
			}, 0);
		},
		created() {
			this.PageInit()
		}
	}
</script>
